import { normalizeRedirectPath, storeRedirectPathTo } from './redirectUtils';

const BOOKING_DESKTOP_PARAM = 'booking';
const BOOKING_PHONE_PARAM = 'booking-phone';

const toStudioPath = (studioId) => (studioId ? `/studio/${studioId}` : '/');

export const buildStudioBookingRedirectLocation = ({
  studioId,
  isPhoneSize = false,
  currentLocation = null,
} = {}) => {
  const studioPath = toStudioPath(studioId);
  const isCurrentStudioPath = currentLocation?.pathname === studioPath;
  const params = new URLSearchParams(isCurrentStudioPath ? currentLocation?.search || '' : '');
  const openParam = isPhoneSize ? BOOKING_PHONE_PARAM : BOOKING_DESKTOP_PARAM;
  const staleParam = isPhoneSize ? BOOKING_DESKTOP_PARAM : BOOKING_PHONE_PARAM;

  params.delete(staleParam);
  params.set(openParam, 'open');

  const search = params.toString();

  return {
    pathname: studioPath,
    search: search ? `?${search}` : '',
    hash: isCurrentStudioPath ? currentLocation?.hash || '' : '',
  };
};

export const getStudioBookingRedirectPath = (options) => (
  normalizeRedirectPath(buildStudioBookingRedirectLocation(options))
);

export const storeStudioBookingRedirect = (options) => (
  storeRedirectPathTo(buildStudioBookingRedirectLocation(options))
);

export const buildBookingAuthNavigationState = ({ location, from }) => ({
  background: location,
  from,
  requiresAuth: true,
});

const AUTH_ERROR_TOKENS = [
  'notauthorizedexception',
  'userunauthenticatedexception',
  'unauthorized',
  'not authenticated',
  'not signed in',
  'no current user',
  'auth token',
  'jwt expired',
  'token expired',
  'access token',
];

export const isBookingAuthError = (error) => {
  if (!error) return false;

  const status = Number(
    error.statusCode
    || error.status
    || error.response?.status
    || error.networkError?.statusCode
    || error.networkError?.status
  );

  if (status === 401) return true;

  const values = [
    error.name,
    error.code,
    error.errorType,
    error.message,
    error.response?.data?.message,
    error.networkError?.message,
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  if (values.some((value) => AUTH_ERROR_TOKENS.some((token) => value.includes(token)))) {
    return true;
  }

  return Array.isArray(error.graphQLErrors)
    && error.graphQLErrors.some((graphQLError) => isBookingAuthError(graphQLError));
};
